"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
const merlin_typography_1 = require("@travelnest/merlin.typography");
const merlin_inline_message_1 = require("@travelnest/merlin.inline-message");
const merlin_spacer_1 = require("@travelnest/merlin.spacer");
const Wrapper = styled_1.default.div `
	box-sizing: border-box;
	max-width: 400px;
	width: 100%;
	position: relative;
	:after {
		content: '';
		display: block;
		position: absolute;
		top: -2px;
		bottom: 2px;
		right: -2px;
		left: -2px;
		opacity: 0;
		border: 1px solid ${merlin_theme_1.default.colours.highlight.default};
		transition: opacity ${merlin_theme_1.default.motion.transition.default};
		-webkit-transition: opacity ${merlin_theme_1.default.motion.transition.default};
		pointer-events: none;
		border-radius: calc(${merlin_theme_1.default.layout.radius.squared} + 1px);
	}

	/* transition on opacity - fades in when focused */
	:focus-within:after {
		opacity: 1;
	}
`;
const FormTextArea = styled_1.default.textarea `
	outline: none;
	box-sizing: border-box;
	resize: none;
	width: 100%;
	height: 400px;
	border: 1px solid ${merlin_theme_1.default.colours.neutral.light};
	border-radius: ${merlin_theme_1.default.layout.radius.squared};
	padding: ${merlin_theme_1.default.layout.spacing.standard} ${merlin_theme_1.default.layout.spacing.small};
	${merlin_theme_1.default.typography.c3};
	background: #ffffff;
	transition: border 0.2s;

	&:focus, &:hover, &:active {
		border: 1px solid ${merlin_theme_1.default.colours.neutral.dark};
		${({ valid }) => !valid && `
			border-color: ${merlin_theme_1.default.colours.error.default};
			color: ${merlin_theme_1.default.colours.error.default};
			background-color: ${merlin_theme_1.default.colours.error.tint};
		`};
	}
	&:disabled, &:read-only {
		background: ${merlin_theme_1.default.colours.neutral.lighter};
		color: ${merlin_theme_1.default.colours.neutral.darker};
		cursor: not-allowed;
		opacity: 1;
	}
	&:disabled:hover, &:read-only:hover {
		border: 1px solid ${merlin_theme_1.default.colours.neutral.light};
	}

	${({ valid }) => !valid && `
		border-color: ${merlin_theme_1.default.colours.error.default};
		color: ${merlin_theme_1.default.colours.error.default};
		background-color: ${merlin_theme_1.default.colours.error.tint};
	`};
`;
const CharacterCount = styled_1.default.div `
	${merlin_theme_1.default.typography.d2};
`;
const TextArea = (_a) => {
    var { valid, value, onChange, maxLength, minLength = 1, name = '', disabled, errorMessage, id, label, hintText } = _a, props = __rest(_a, ["valid", "value", "onChange", "maxLength", "minLength", "name", "disabled", "errorMessage", "id", "label", "hintText"]);
    const showLabel = label && (React.createElement(React.Fragment, null,
        React.createElement(merlin_typography_1.Label, { htmlFor: id }, label),
        React.createElement(merlin_spacer_1.Spacer, { spacing: "smaller" })));
    const showHintText = hintText && (React.createElement(React.Fragment, null,
        React.createElement(merlin_typography_1.HintText, { id: `${id}-hint` }, hintText),
        React.createElement(merlin_spacer_1.Spacer, { spacing: "smaller" })));
    return (React.createElement(React.Fragment, null,
        showLabel,
        showHintText,
        React.createElement(Wrapper, null,
            React.createElement(FormTextArea, Object.assign({ id: id, "data-testid": `${id}-textarea`, name: name, minLength: minLength, maxLength: maxLength, onChange: (e) => onChange(name, e.target.value), disabled: disabled, valid: valid, value: value }, props))),
        React.createElement(merlin_spacer_1.Spacer, { spacing: "smaller" }),
        !valid && errorMessage && (React.createElement(React.Fragment, null,
            React.createElement(merlin_inline_message_1.InlineError, { text: errorMessage }),
            React.createElement(merlin_spacer_1.Spacer, { spacing: "smaller" }))),
        !disabled && (React.createElement(CharacterCount, { "data-testid": `${name}-character-length-text` }, `(minimum ${minLength}) ${(value && value || []).length}/${maxLength}`))));
};
exports.TextArea = TextArea;
//# sourceMappingURL=TextArea.js.map